<template>
  <CRow>
    <CCol>
      <CCard class="p-3">
        <CCardHeader>
          <div class="countCard_Header d-flex justify-content-between content-center mb-4">
            <h5>{{ $t('settings.planAndBilling.payment.header') }}</h5>
          </div>
        </CCardHeader>
        <CCardBody class="">
          <CAlert class="mt-1 mb-3 font-sm" color="info">
            <div class="d-flex align-items-baseline text-black">
              <div>
                <CIcon name="infoCircle" size="custom-size" class="mr-2" :height="15" style="transform: rotate(180deg)" viewBox="0 0 32 32" />
              </div>
              <p class="mb-0">
                {{ $t('settings.planAndBilling.payment.text.payment-method-alert') }}
              </p>
            </div>
          </CAlert>
          <div class="currentPlan mt-3">
            <CRow>
              <CCol sm="5" class="">
                <div class="colCardVisa">
                  <CIcon :name="cardCinzaBandeira" size="custom-size" class="text-gray-500 pr-1 iconVisaOverview" :height="50" viewBox="0 0 32 32" />
                </div>
              </CCol>
              <CCol sm="6" class="">
                <div class="paymentTitle mt-2">{{ $t('settings.planAndBilling.payment.text.paymentDetails') }}</div>
                <div class="cardDetail mt-1">
                  {{ $t('settings.planAndBilling.payment.text.creditCard') }}
                  <CIcon :name="paymentMethod.brand" size="custom-size" :height="22" viewBox="0 0 32 32" /> **** {{ paymentMethod.last4 }} |
                  {{ $t('settings.planAndBilling.payment.text.expires') }}: {{ expiresDateString() }}
                </div>
                <div class="paymentDetailMessage mt-1">An update to your current subscription will be reflected.</div>

                <button class="btn-overview btn-overview-cancel mt-4" @click="changeCardInfoClick()">Update</button>
              </CCol>
            </CRow>
          </div>
        </CCardBody>
      </CCard>

      <CModal :title="changeCardInfoTitle" :show.sync="changeCardInfoModal">
        <CardModalContent v-if="changeCardInfoModal" @error="changeCardInfoPaymentError" @close="closeCardModal" @update="updatePayment()" />
        <template #footer><div></div></template>
      </CModal>
    </CCol>
  </CRow>
</template>

<script>
import CardModalContent from './CardPaymentForm.vue'

let cardCinza = {
  visa: 'cibCcVisa',
  mastercard: 'cibCcMastercard',
}

export default {
  name: 'OverViewPayment',
  components: {
    CardModalContent,
  },
  props: {
    paymentMethod: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      changeCardInfoModal: false,
      changeCardInfoTitle: this.$t('settings.planAndBilling.payment.modal.header.changeCardPaymentInfo'),
    }
  },
  computed: {
    cardCinzaBandeira: function () {
      return cardCinza[this.paymentMethod.brand]
    },
  },
  methods: {
    changeCardInfoClick() {
      this.changeCardInfoModal = true
    },
    changeCardInfoPaymentError(error) {
      this.$emit('error-payment', error)
    },
    closeCardModal() {
      this.changeCardInfoModal = false
    },
    updatePayment() {
      this.$emit('update-payment')
      this.changeCardInfoModal = false
    },
    expiresDateString() {
      return (this.paymentMethod.expMonth < 10 ? '0' + this.paymentMethod.expMonth : this.paymentMethod.expMonth) + '/' + this.paymentMethod.expYear
    },
  },
}
</script>

<style lang="scss" scope>
.paymentTitle {
  font-size: 16px;
  color: #343a40;
  font-weight: bold;
}

.paymentDetailMessage {
  color: #868e96;
  font-size: 12px;
}

.cardDetail {
  color: #343a40;
  font-size: 15px;
}
.colCardVisa {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  height: 170px;
  width: 280px;
  text-align: center;
}
.iconVisaOverview {
  margin-top: 55px;
}
.currentPlan {
  border-radius: 10px;
  border: 1px solid #dee2e6;
  padding: 20px;
}

.currentPlanColOne {
  border-right: 1px solid #dee2e6;
  text-align: center;
  padding: 50px 20px;
}

.currentPlanColOne h6 {
  font-size: 0.9rem;
  line-height: 140px;
}

.checkMark {
  color: #ff5924;
}

.blockFeatures {
  color: #343a40;
  font-size: 14px;
}

.currentPlanColThree {
  text-align: center;
}
</style>
